// Front-end only — no back-end counterpart.

export type VenueSection = 'cuisines' | 'ideal-for' | 'seating-capacity'

export const VenueSection = {
  CUISINES: 'cuisines',
  IDEAL_FOR: 'ideal-for',
  SEATING_CAPACITY: 'seating-capacity'
} satisfies Record<string, VenueSection>

export const VenueSectionValues: readonly VenueSection[] = Object.values(VenueSection)
